<template>
  <div>
    <back-btn />

    <v-container>
      <v-card class="card--shadow mb-2">
        <v-card-text>
          <patient-info :patient="patient" />
        </v-card-text>
      </v-card>
      <v-card class="card--shadow">
        <v-card-title class="purple accent-4">
          <div class="subtitle-1 white--text text-uppercase">
            Patient's DRTB Regimen
          </div>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col lg="4">
              <label>DRTB Regimen</label>
              <v-select
                v-model="mdrtb_regiment"
                :items="mdrTbRegs"
                item-text="text"
                item-value="id"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col lg="4" v-show="Number(mdrtb_regiment) == 3">
              <label>Drug Name</label>
              <v-text-field
                v-model.trim="description"
                type="text"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col lg="4" v-show="Number(mdrtb_regiment) == 11">
              <label>Other treatment regimen</label>
              <v-select
              :items="[
                  { id:'1', text: 'SSTR' },
                  { id: '2', text: 'Poly Resistant' },
                  { id: '3', text: 'Mono Resistant' },
                ]"
                item-text="text"
                item-value="id"
                v-model="mdrtb_regiment_other"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col lg="4">
              <label>Date</label>
              <date-picker
                @clearDate="date = null"
                :date="date"
                v-model="date"
              />
            </v-col>
          </v-row>
          <div class="d-flex justify-end">
            <v-btn @click.prevent="saveData" class="form-btn">
              <v-icon left>mdi-chevron-right-circle-outline</v-icon>submit
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
      <v-card class="mt-2 card--shadow">
        <!-- <v-card-title class="purple accent-4">
        <div class="subtitle-1 white--text text-uppercase">
          Patient's DRTB Regimen List
        </div>
        </v-card-title>-->
        <v-simple-table>
          <thead class="header">
            <tr>
              <th class="header--text">No</th>
              <th class="header--text">DRTB Regimen</th>
              <th class="header--text">Drug Name</th>
              <th class="header--text">Other treatment regimen</th>
              <th class="header--text">Date</th>
              <th class="header--text">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in mdrtbRegiments" v-bind:key="item.id">
              <td>{{ index + 1 }}</td>
              <td>{{ getText(item.mdrtb_regiment_id) }}</td>
              <td>{{ item.mdrtb_regiment_text }}</td>
              <td>{{ item.mdrtb_regiment_other }}</td>
              <td>{{ item.date }}</td>
              <td>
                <v-btn
                  v-show="canDelete(item)"
                  @click="deleteData(item)"
                  icon
                  color="red lighten-1"
                  class="white--text"
                  depressed
                >
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import BackBtn from "@/components/navigation/BackBtn.vue";
import DatePicker from "@/components/common/DatePicker.vue";
import PatientInfo from "../component/patientInfo.vue";

export default {
  components: { BackBtn, DatePicker, PatientInfo },
  computed: {
    ...mapState("InfoData", ["mdrTbRegs"]),
    ...mapState("MDRTBRegiment", ["mdrtbRegiments"]),
    ...mapState("Patient", ["patient"]),
    
  },
  data() {
    return {
      mdrtb_regiment: "",
      date: "",
      description: "",
      menu2: null,
      mdrtb_regiment_other:"",
    };
  },
  methods: {
    saveData() {
      if (this.mdrtb_regiment) {
        if (
          this.mdrtbRegiments.length > 0 ||
          this.date == this.patient.treatment_startdate
        ) {
          this.$store.dispatch("MDRTBRegiment/store", {
            patient_id: this.$route.params.id,
            mdrtb_regiment_id: this.mdrtb_regiment,
            mdrtb_regiment_text: this.description,
            date: this.date,
            mdrtb_regiment_other:this.mdrtb_regiment_other,
          });
        } else {
          this.$toast.error(
            `Date should be the same to patient's treatment startdate (${this.patient.treatment_startdate})`,
            { position: "top-center" }
          );
        }
      }
    },
    getText(id) {
      var text = "";
      if (this.mdrTbRegs) {
        this.mdrTbRegs.map((val) => {
          if (val.id == id) {
            text = val.text;
          }
        });
      }
      return text;
    },
    deleteData(item) {
      this.$store.dispatch("MDRTBRegiment/delete", {
        id: item.id,
      });
    },
    canDelete(item) {
      var sep = new Date(item.created_at);
      var today = new Date();
      var diff = (today.getTime() - sep.getTime()) / 1000;
      diff /= 60 * 60;
      diff = Math.abs(Math.round(diff));

      if (diff < 24) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.$store.dispatch("Patient/getPatient", this.$route.params.id);

    this.$store.dispatch("MDRTBRegiment/getAll", {
      patient_id: this.$route.params.id,
    });
  },
};
</script>

<style></style>
